import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Shirt, Tag } from "lucide-react";

/**
 * Task 9 - asked once when a piece is first listed:
 *   "Keep wearing it until it sells"  -> stays in the closet + outfit suggestions (sale_rack = "wear")
 *   "Move it to the For Sale rack"    -> leaves the everyday closet view and the generator (sale_rack = "rack")
 */
export const SaleRackPrompt = ({ open, count = 1, onChoose, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md" data-testid="sale-rack-prompt">
      <DialogHeader>
        <DialogTitle className="font-display text-2xl">While it's listed…</DialogTitle>
        <DialogDescription>{count > 1 ? `These ${count} pieces are` : "This piece is"} now for sale. What should happen in your closet until {count > 1 ? "they sell" : "it sells"}?</DialogDescription>
      </DialogHeader>
      <div className="grid gap-2">
        <button onClick={() => onChoose("wear")} className="text-left rounded-2xl border border-border p-4 hover:border-foreground transition-colors" data-testid="sale-rack-wear">
          <p className="font-semibold inline-flex items-center gap-2"><Shirt className="h-4 w-4" /> Keep wearing {count > 1 ? "them" : "it"} until {count > 1 ? "they sell" : "it sells"}</p>
          <p className="text-xs text-muted-foreground mt-1">Stays in your closet and in outfit suggestions, with a For sale banner.</p>
        </button>
        <button onClick={() => onChoose("rack")} className="text-left rounded-2xl border border-border p-4 hover:border-foreground transition-colors" data-testid="sale-rack-rack">
          <p className="font-semibold inline-flex items-center gap-2"><Tag className="h-4 w-4" /> Move {count > 1 ? "them" : "it"} to the For Sale rack</p>
          <p className="text-xs text-muted-foreground mt-1">Out of the everyday closet and outfit suggestions - find {count > 1 ? "them" : "it"} under the For sale tab.</p>
        </button>
      </div>
    </DialogContent>
  </Dialog>
);
